import type { BankMessagesFeatureConfig } from './type';

export const AT: BankMessagesFeatureConfig = {
    getMessageAcceptHeader: 'application/vnd.at.spardat.rest.netbanking.model.message.v1+json',
};
